<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>

    <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important;  margin-left: -7px;">
      <div class="card" style="height: 1000px;">
        <div class="card-body">
          <div class="d-flex justify-content-start" style="margin-top: 0 !important;">
            <button type="button" class="btn custom-button" style="margin-bottom:10px ;"   (click)="goBack()">Back</button>
          </div>
         
          
<!-- new -->
<div class="new-card"
      style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: -15px; font-family: 'Segoe UI', sans-serif; ">
  <div class="card-content">
    <div class="row d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px; font-size: 15px; color: #333;">
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Code:</strong> {{ studyCode }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Name:</strong> {{ studyName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Subject Name:</strong> {{ subjectName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Site Location:</strong> {{ siteLocation }}
      </div>
    </div>
  </div>
</div>

            <div *ngIf="formName === 'idrs-form-log'" class="card mt-4" >
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="m-0">Assessment Form</h5>
                    <!--<button type="button" class="btn custom-button">Create Field</button>-->
                </div>
            <!-- Small Modal (Right-side) -->
        <div class="options-modal" *ngIf="isOptionsModalOpen" (click)="$event.stopPropagation()" style="margin-top: 56px; margin-right: 62px;">
  <div class="modal-buttons">
    <button (click)="openModal()">Query</button>
    <button (click)="editStudy()">Edit</button>
    <button (click)="openReviewModal()">Review</button>
  </div>
  </div>
   <div class="modal-overlay" *ngIf="isReasonModalOpen">
  <div class="modal-content">
    <button class="close-btn" (click)="cancelEditReason()">×</button>
    <h4>Please provide a reason for editing:</h4>
    <textarea class="form-control" [(ngModel)]="editReason" rows="4" placeholder="Enter reason here..."></textarea>
    <div class="modal-footer">
      <button class="btn custom-button" (click)="confirmEditReason()">Confirm</button>
      <button class="btn custom-button" (click)="cancelEditReason()">Cancel</button>
    </div>
  </div>
</div>
<!-- Review Modal for IDRS -->
<div class="modal-overlay1" *ngIf="showReviewModal" (click)="closeReviewModal()">
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <span
      class="close-button1"
      (click)="closeReviewModal()"
      style="position: absolute; top: 1px; right: 16px; font-size: 22px; cursor: pointer; color: #999; z-index: 10;"
    >
      ×
    </span>

    <div class="checkbox-group" style="padding-top: 1.5rem;">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()">×</span>
  <div class="modal-content1" (click)="$event.stopPropagation()">

    <!-- Data Monitor -->
    <div class="checkbox-group">
      <div class="form-check" style="margin-top: 20px;">
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="idrsBySection[activeSection]?.reviewOptions.dataMonitor"
          [disabled]="!hasIdrsData || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange(activeSection)">
        <label for="reviewedByDataMonitor">Reviewed by Data Monitor</label>
      </div>
    </div>

    <!-- Monitor -->
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="idrsBySection[activeSection]?.reviewOptions.monitor"
          [disabled]="!hasIdrsData || !idrsBySection[activeSection]?.reviewOptions.dataMonitor || userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange(activeSection)"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="idrsBySection[activeSection]?.reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="idrsBySection[activeSection]?.reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
          [disabled]="
            !hasIdrsData ||
            !idrsBySection[activeSection]?.reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange(activeSection)"
        />
        <label for="reviewedByMonitor">Reviewed by Monitor</label>
      </div>
    </div>

    <!-- PI -->
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="idrsBySection[activeSection]?.reviewOptions.pi"
          [disabled]="!hasIdrsData || !idrsBySection[activeSection]?.reviewOptions.dataMonitor || !idrsBySection[activeSection]?.reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="idrsBySection[activeSection]?.reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="idrsBySection[activeSection]?.reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
          [disabled]="
            !hasIdrsData ||
            !idrsBySection[activeSection]?.reviewOptions.dataMonitor ||
            !idrsBySection[activeSection]?.reviewOptions.monitor ||
            userDesignation !== 'pi'"
          (change)="onReviewCheckboxChange(activeSection)"
        />
        <label for="reviewedByPI">Reviewed by PI</label>
      </div>
    </div>

  </div>
</div>

        
        <div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content">
     <button class="close-btn" (click)="closeModal()">&times;</button>
     
    <!-- Tab Bar -->
    <div class="tab-bar">
      <div 
        class="tab" 
        *ngFor="let tab of tabs; let idx = index" 
        [class.active]="selectedTab === idx" 
        (click)="selectTab(idx)">
        {{ tab.title }}
        <span class="close-tab" *ngIf="tabs.length > 1" (click)="closeTab(idx, $event)">×</span>
      </div>
      
      <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
       <div *ngIf="tabs[selectedTab].type === 'query'" class="add-btn-wrapper">
          <button class="add-btn" (click)="addQuery(i)">+</button>
          <span class="add-query-tooltip">Add Query</span>
        </div> 
    </div>
   

    <!-- Modal Body -->
    <div class="modal-body">
      <ng-container [ngSwitch]="tabs[selectedTab].type">

        <!-- Query Tab -->
        <div *ngSwitchCase="'query'">
          <div *ngFor="let query of queries; let i = index" class="query-box">
              <!-- Dropdown Field -->
          <select class="form-select mb-2" [(ngModel)]="query.selectedField" [disabled]="query.isClosed">
            <option>Select Column</option>
            <option>Logline No.</option>
            <option>Assessment Type</option>
            <option>Criteria</option>
            <option>Criteria Valid</option>
            <option>Score to be Given</option>
            <option>Score Given</option>
          </select>
          <br>
            <div class="input-checkbox-container">
            
              <input
                type="text"
                class="form-control"
                [value]="''"
                (input)="query.text = $event.target.value"
                [readonly]="query.isClosed"
                [ngClass]="{ 'query-closed': query.isClosed }"
                placeholder="Enter your query"
              />



              
             
            </div>
            
            <!-- Audit Trail -->
            <div class="audit-trail">
              <h4>Audit Trail</h4>
              <div class="audit-entry" *ngFor="let entry of query.auditTrail">
                <strong>{{ entry.user }}</strong>- {{ entry.timestamp | date: 'dd-MMM-yyyy h:mm a' }}

                <p>{{ entry.message }}</p>
              </div>
            </div>
            <div class="modal-footer">
      <button class="btn custom-button" (click)="confirmCloseQuery(i)">Close Query</button>
      <button class="btn custom-button ms-2" (click)="confirmSubmitQuery(i)">Submit</button>
      
    </div>
          </div>
        </div>

        <!-- Field History Tab -->
        <div *ngSwitchCase="'fieldHistory'">
          <div *ngIf="fieldHistoryData?.length > 0; else noData">
            <div *ngFor="let entry of fieldHistoryData" class="history-box">
              <div class="history-header">
                <strong>{{ entry.updated_by }}</strong> - {{ entry.updated_at | date: 'medium' }}
              </div>
             <div class="history-value">
                {{ entry.sub_data }}
              </div>
              <!-- ✅ Show edit reason if available -->
      <div class="edit-reason" *ngIf="entry.edit_reason">
        <em>Reason for change: {{ entry.edit_reason }}</em>
      </div>
       <div class="log-label" *ngIf="entry.field_name">
    <small>Field: {{ entry.field_name }}</small>
  </div>
            </div>
          </div>
          <ng-template #noData>
            <p>No history available for this field.</p>
          </ng-template>
        </div>

      </ng-container>
    </div>


    
  </div> 
</div>
                 <div class="card-body scrollable-container">
    <div *ngFor="let section of sectionNames">
      <div class="card mt-2">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="m-0">{{ section }} IDRS</h5>
          <div class="menu-icon" (click)="openOptionsModal($event, $event.target, section)" style="margin-left: 100px;">⋮</div>
        </div>

        <div class="card-body">
          <form (ngSubmit)="submitForm(section)">
            <div class="table-wrapper">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Logline No.</th>
                    <th>Assessment Type</th>
                    <th>Criteria</th>
                    <th>Criteria Valid</th>
                    <th>Score to be Given</th>
                    <th>Score Given</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of idrsBySection[section].data; let i = index">
                    <td>{{ item.loglineNo }}</td>
                    <td>{{ item.assessmentType }}</td>
                    <td>
                      <ng-container *ngIf="item.assessmentType === 'Abdominal obesity (waist circumference)'">
                        <ng-container *ngIf="gender === 'Female'">
                          <select [(ngModel)]="item.selectedCriteria" [name]="section + '_criteriaFemale' + i" (change)="calculateScore(section, i)" [disabled]="idrsBySection[section].isDisabled">
                            <option *ngFor="let option of item.criteriaOptionsFemale" [ngValue]="option">{{ option.label }}</option>
                          </select>
                        </ng-container>
                        <ng-container *ngIf="gender === 'Male'">
                          <select [(ngModel)]="item.selectedCriteria" [name]="section + '_criteriaMale' + i" (change)="calculateScore(section, i)" [disabled]="idrsBySection[section].isDisabled">
                            <option *ngFor="let option of item.criteriaOptionsMale" [ngValue]="option">{{ option.label }}</option>
                          </select>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngIf="item.assessmentType !== 'Abdominal obesity (waist circumference)'">
                        <select [(ngModel)]="item.selectedCriteria" [name]="section + '_criteria' + i" (change)="calculateScore(section, i)" [disabled]="idrsBySection[section].isDisabled">
                          <option *ngFor="let option of item.criteriaOptions" [ngValue]="option">{{ option.label }}</option>
                        </select>
                      </ng-container>
                    </td>
                    <td>
                      <input type="checkbox" [(ngModel)]="item.criteriaValid" [name]="section + '_criteriaValid' + i" (change)="calculateScore(section, i)" [disabled]="idrsBySection[section].isDisabled">
                    </td>
                    <td>{{ item.scoreToBeGiven }}</td>
                    <td>
                      <select [(ngModel)]="item.scoreGiven" [name]="section + '_scoreGiven' + i" (change)="onScoreGivenChange()" [disabled]="idrsBySection[section].isDisabled">
                        <option *ngFor="let score of [0, 10, 20, 30]" [value]="score">{{ score }}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5" class="text-end"><strong>Total Score Given:</strong></td>
                    <td><strong>{{ getTotalScoreGiven(section) }}</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- Submit Button -->
            <div class="text-end">
              <button type="submit" class="btn custom-button" >
                Submit {{ section }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  
    </div>
    </div>
    </div>
    </div>